/* eslint-disable */
import React, { useMemo, useState, useEffect } from "react";

// Images
import reviewImage1 from "../../images/hookPicture1.png";
import reviewImage2 from "../../images/hookPicture2.png";
import reviewImage3 from "../../images/hookPicture3.png";
import reviewImage4 from "../../images/hookPicture4.png";

export default function HookSection({ cards, className = "" }) {
  const fallbackCards = useMemo(
    () => [
      {
        title: "You’re losing hair",
        text:
          "You’re frustrated about losing your hair and want to make a serious change.",
        img: reviewImage1,
      },
      {
        title: "You’re considering a hair transplant",
        text:
          "You want to learn more about hair transplants but don’t know where to start.",
        img: reviewImage2,
      },
      {
        title: "You're confused about which doctor to choose",
        text:
          "You want to get a hair transplant but are not sure how to choose the best doctor.",
        img: reviewImage3,
      },
      {
        title: "You want expert guidance about hair transplants",
        text:
          "You want an actual person to talk to experienced in hair transplant industry.",
        img: reviewImage4,
      },
    ],
    []
  );

  const data =
    Array.isArray(cards) && cards.length >= 4 ? cards.slice(0, 4) : fallbackCards;

  const [active, setActive] = useState(0);
  const [imgKey, setImgKey] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size on mount + resize
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handlePick = (i) => {
    setActive(i);
    if (!isMobile) setImgKey((k) => k + 1); // retrigger animation only on md+
  };

  return (
    <section className={`md:mt-4 w-full bg-transparent ${className}`}>
      <div className="w-11/12 xl:w-5/6 mx-auto py-10 md:py-12">
        {/* Title */}
        <h2 className="text-center text-3xl md:text-4xl font-extrabold">
          You&apos;re in the right place, if
        </h2>

        {/* Image + Cards */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-stretch">
          {/* Left: Image */}
          <div className="md:col-span-5 h-full">
            <div className="relative h-full overflow-hidden rounded-2xl">
              <img
                key={imgKey}
                src={isMobile ? reviewImage2 : data[active].img}
                alt=""
                className="h-full w-full min-h-[220px] object-cover aspect-square animate-fadeInScale"
              />
            </div>
          </div>

          {/* Right: Cards */}
          <div className="md:col-span-7 h-full">
            <div className="flex flex-col gap-3 h-full justify-evenly">
              {data.map((card, i) => {
                const selected = i === active;
                return (
                  <button
                    key={i}
                    type="button"
                    onClick={() => handlePick(i)}
                    aria-pressed={selected}
                    className={[
                      "w-full text-left rounded-xl border-gray-200 border px-5 py-4 transition",
                      selected ? "border-gray-300 bg-gray-100" : "",
                    ].join(" ")}
                  >
                    <h3 className="text-lg md:text-lg font-semibold">{card.title}</h3>
                    <p className="mt-1.5 text-base md:text-base text-gray-600">{card.text}</p>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Tiny appear animation */}
      <style>{`
        @keyframes fadeInScale {
          0% { opacity: 0; transform: scale(0.98); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-fadeInScale {
          animation: fadeInScale 260ms cubic-bezier(0.22, 1, 0.36, 1);
        }
      `}</style>
    </section>
  );
}
